import { EChartsOption } from 'echarts'

import { IChartSeries } from '$/types'
import { getBaseDonutChartConfig } from 'common/utils/chart/pie/donutChartUtils'
import Echart from 'common/components/Echart'
import GraphContainerCard from 'features/RiskManagement/Components/Graphs/Components/GraphContainerCard'

interface IGenericDonutChart {
  showLoading: boolean
  title: string
  categories: string[]
  s1Values: number[]
  s2Values?: number[]
  valueLabel?: string
  unitSymbol?: string
  s1Label?: string
  s2Label?: string
  graphType?: string
}

export const GenericDonutChart = ({
  showLoading,
  title,
  graphType,
  categories,
  s1Values,
  s2Values,
  valueLabel,
  unitSymbol,
  s1Label,
  s2Label
}: IGenericDonutChart) => {
  const series: IChartSeries[] = [
    {
      label: s1Label,
      values: s1Values
    },
    {
      label: s2Label,
      values: s2Values
    }
  ]

  const options: EChartsOption = getBaseDonutChartConfig({
    categories,
    series,
    valueLabel,
    unitSymbol,
    title,
    graphType
  })

  return (
    <GraphContainerCard title={title}>
      <Echart notMerge option={options} showLoading={showLoading} />
    </GraphContainerCard>
  )
}
